import React, { useState, useEffect } from 'react';
import { obtenerMatriculaPorId } from '../../services/matriculaService';
import DatosPersonales from './datos_personales';
import DatosMedicos from './datos_medicos';
import DesarrolloMotrizLenguaje from './desarrollo_motriz_lenguaje';
import DesarrolloSocialAfectivo from './desarrollo_social_afectivo';
import Antecedentes from './antecedentes';
import MatriculaDatos from './matricula_datos';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DetalleMatriculaPadre = () => {
  const [matricula, setMatricula] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cargarMatricula = async () => {
      try {
        const hijoSeleccionado = JSON.parse(localStorage.getItem('hijoSeleccionado'));
        if (!hijoSeleccionado) {
          throw new Error('No hay un hijo seleccionado');
        }

        const response = await obtenerMatriculaPorId(hijoSeleccionado.id_child);
        setMatricula(response.matricula);
      } catch (err) {
        setError(err.message);
        console.error('Error al cargar la matrícula:', err);
      }
    };

    cargarMatricula();
  }, []);

  if (error) {
    return <div className="text-red-500 p-4">{error}</div>;
  }

  if (!matricula) {
    return <div className="p-4">Cargando matrícula...</div>;
  }

  return (
    <div className="h-[calc(100vh-12rem)] overflow-y-auto">
      <ToastContainer />
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-6 p-4">
        <DatosPersonales matricula={matricula} />
        <DatosMedicos matricula={matricula} />
        <DesarrolloMotrizLenguaje matricula={matricula} />
        <DesarrolloSocialAfectivo matricula={matricula} />
        <Antecedentes matricula={matricula} />
        <MatriculaDatos matricula={matricula} />
      </div>
    </div>
  );
};

export default DetalleMatriculaPadre;
